<template>
    <span class="product">
            <a :href="data.detail_url">

                <template v-if="data.badges && data.badges.length > 0">
                     <span class="product-badge"
                           v-for="(badge, index) in data.badges"
                           :key="index"
                           :style="{ backgroundColor: badge.color }"
                     >
                        {{ badge.name }}
                    </span>
                </template>

                <div class="product-thumb" v-if="data.image_url">
                <img :src="data.image_url"
                     :alt="data.name">
            </div>
            <div class="text">
                <a :href="data.detail_url">
                    <div class="info">

                        <template v-if="data.brand">
                            <img v-if="data.brand.image" :src="/storage/+data.brand.image" :alt="data.brand.name" class="brandIcon" />
                            <span v-else class="badge">{{ data.brand.name }}</span>
                        </template>

                        <span v-if="data.stock > 0" class="stock on-stock">{{ textStock }} {{ data.quantity_formatted }} {{ data.mu }}</span>
                        <span v-else class="stock on-order">{{ textNotStock }}</span>

                    </div>
                    <h3>{{ data.name }}</h3>
                </a>
                <div class="action">
                <a :href="data.url">
                    <div class="price">
                        <span class="main-price">{{ data.main_price }} {{ textCurr }}</span>
                        <span class="price-without-tax">{{ data.main_price_without_tax }} {{ textCurr }} bez DPH</span>
                    </div>
                </a>

                    <AddToCartList
                        :route="data.cart_url"
                        :product-id="data.id"
                        :gtm-data-p="gtmData"
                        v-if="parseFloat(data.stock) > 0"/>
                </div>
            </div>
    </a>
        </span>

</template>

<script>
import { inject, onMounted, reactive, toRefs } from 'vue'
import {getCategoryByPosition} from "../../../../../functions";
import AddToCartList from "../../../buttons/AddToCartList.vue";

export default {

    props: [
        'data',
        'textStock',
        'textNotStock',
        'textCurr',
        'btnText',
        'btnTextInCart',
        'btnTextRemove',
        'btnTextAddToCart',
    ],

    components: {
        AddToCartList,
    },

    setup(props) {

        const state = reactive({
            gtmData: {
                currency: 'EUR',
                value: props.data.main_price_without_tax,
                items: [{
                    item_id: props.data.external_id,
                    item_name: props.data.name,
                    affiliation: 'Eshop',
                    coupon: '',
                    discount: '',
                    index: 1,
                    item_brand: props.data.brand ? props.data.brand.name : '',
                    item_category: props.data.categories_with_depth ? getCategoryByPosition(1, props.data.categories_with_depth) : null,
                    item_category2: props.data.categories_with_depth ? getCategoryByPosition(2, props.data.categories_with_depth) : null,
                    item_category3: props.data.categories_with_depth ? getCategoryByPosition(3, props.data.categories_with_depth) : null,
                    item_category4: props.data.categories_with_depth ? getCategoryByPosition(4, props.data.categories_with_depth) : null,
                    item_category5: props.data.categories_with_depth ? getCategoryByPosition(5, props.data.categories_with_depth) : null,
                    item_list_id: '',
                    item_list_name: '',
                    item_variant: '',
                    location_id: '',
                    price: props.data.main_price_without_tax,
                    quantity: 1
                }]
            }
        })

        onMounted( () => {
            // console.log(props.data)
            // console.log(state.gtmData)
        })

        return {
            ...toRefs(state)
        }
    }
}
</script>
